export default function reducer(state, action) {
	const { type } = action;

	switch (type) {
		case 'SET_ACTIVE_KEY':
			const { activeKey } = action;
			return { ...state, activeKey: activeKey };

		case 'SET_ACTIVE_TRANSLATION_KEY':
			const { activeTranslationKey } = action;
			return { ...state, activeTranslationKey: activeTranslationKey };

		case 'SET_ACTIVE_TAG':
			const { activeTag } = action;
			return { ...state, activeTag: activeTag };

		case 'SET_ACTIVE_CATEGORY':
			const { activeCategory } = action;
			return { ...state, activeCategory: activeCategory };

		case 'SET_KEYS':
			const { keys } = action;
			return { ...state, keys: keys };

		case 'SET_DRAFTS':
			const { drafts } = action;
			return { ...state, drafts: drafts };

		case 'SET_DELETED':
			const { deleted } = action;
			return { ...state, deleted: deleted };

		case 'SET_TAGS':
			const { tags } = action;
			return { ...state, tags: tags };

    case 'SET_PLATFORM_TAGS':
      const { platformTags } = action;
      return { ...state, platformTags: platformTags };

    case 'SET_CATEGORIES':
			const { categories } = action;
			return { ...state, categories: categories };

		case 'SET_USERS':
			const { users } = action;
			return { ...state, users: users };

		case 'UPDATE_KEYS':
			const { newKey } = action;

			let updateKeys = state.keys;
			let currentIndex = updateKeys.findIndex((k) => k.id == state.activeKey.id);

			let newValue = { ...updateKeys[currentIndex], target: newKey.text, status: newKey.status };
			updateKeys[currentIndex] = newValue;

			return { ...state, keys: updateKeys };

		case 'SET_AUTH_KEY':
			const { key } = action;
			return { ...state, authKey: key };

		case 'SET_ROLES':
			const { roles } = action;
			return { ...state, roles };

		case 'SET_LANGUAGE':
			const { language } = action;
			return { ...state, language: language };

    case 'SET_LANGUAGES':
      const { languages } = action;
      return { ...state, languages: languages };

    case 'SET_REFRESH_TRANSLATIONS':
      const { translationStatus } = action;
      return { ...state, translationStatus: translationStatus };

		default:
			return state;
	}
}
